import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import logo from "../../assets/vmou.png";
import { PDFViewer } from "@react-pdf/renderer";
import {Page, Text, View, Document, StyleSheet, Image} from "@react-pdf/renderer";
import {ToWords} from 'to-words';

const styles = StyleSheet.create({
    page: {
      flexDirection: 'row'
    },
    section: {
      margin: 5
    }
});
const Billprint = (props) => {
    const history = useHistory();
    const [po,setpo] = useState(null);
    useEffect(() => {
        setpo(history.location.state.bill);
      },[history.location.state.bill]);

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return day+"-"+month+"-"+cdt.getFullYear() ;
      };
    let pdfDoc = null;
    if (po) { 
        const toWords = new ToWords();
        pdfDoc = (<Document>
        <Page size="A4" >
            <Text style={{textAlign:'right',fontSize:'9', margin:'40 10 0 20'}}>Form No. 17(E)</Text>
            <View style={{margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'solid', borderWidth:'1px'}}>
                <View style={styles.section}>
                    <Image src={logo} alt="vmou" style={{height:'60px', width:'50px'}}></Image>
                </View>
                <View style={{margin:'5', display:'flex',flexDirection:'col', alignItems: 'flex-end'}}>
                    <Text style={{fontSize:'12',fontStyle:'bold',  margin:'0'}}>Vardhman Mahaveer Open University, Kota</Text>
                    <Text style={{fontSize:'9', margin:'0'}}>Rawatbhata Road</Text>
                    <Text style={{fontSize:'9', margin:'0'}}>KOTA (RAJ.) 324021</Text>
                    <Text style={{fontSize:'9', margin:'0'}}> </Text>
                    <Text style={{fontSize:'8', margin:'0'}}>website: www.vmou.ac.in</Text>
                </View>
            </View>
            <Text style={{textAlign:'center', fontSize:'10',fontStyle:'bold',  margin:'10 0 10 0'}}>Bill For Evaluation - University Exam {po.exam}</Text>
            <View style={{margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between', borderStyle:'none',borderRightWidth:'1px', borderLeftWidth:'1px',borderBottomWidth:'1px',borderTopWidth:'1px'}}>
                <Text style={{fontSize:'9', margin:'5'}}>Bill No: {po.billno}</Text>
                <Text style={{fontSize:'9', margin:'5'}}>Bill Date: {formatDate(po.billdate)}</Text>
            </View>
            <View style={{margin:'0 10 0 20', display:'flex', flexDirection:'row', borderRightWidth:'1px', borderLeftWidth:'1px',borderBottomWidth:'1px'}}>
                <View style={{margin:'3 0 3 5', display:'flex', flexDirection:'col', alignItems: 'flex-Start'}}>
                    <Text style={{fontSize:'10', fontWeight:700}}>Examiner Name : </Text>
                    <Text style={{fontSize:'10', margin:'0'}}>Bank A/c No : </Text>
                    <Text style={{fontSize:'10', margin:'0'}}>Bank Name : </Text>
                    <Text style={{fontSize:'10', margin:'0'}}>Branch Name : </Text>
                    <Text style={{fontSize:'10', margin:'0'}}>IFSC Code : </Text>
                    <Text style={{fontSize:'10', margin:'0'}}>PAN No : </Text>
                </View>
                <View style={{margin:'3 0 3 5', display:'flex', flexDirection:'col', alignItems: 'flex-Start'}}>
                    <Text style={{fontSize:'10', fontWeight:700}}>{po.examinerid.name}</Text>
                    <Text style={{fontSize:'10', margin:'0'}}>{po.examinerid.accno}</Text>
                    <Text style={{fontSize:'10', margin:'0'}}>{po.examinerid.bank}</Text>
                    <Text style={{fontSize:'10', margin:'0'}}>{po.examinerid.branch}</Text>
                    <Text style={{fontSize:'10', margin:'0'}}>{po.examinerid.ifsccode}</Text>
                    <Text style={{fontSize:'10', margin:'0'}}>{po.examinerid.panno}</Text>
                </View>
            </View>
            <View style={{margin:'0 10 0 20', display:'flex', padding:'2px', flexDirection:'row', justifyContent:'space-between',  borderStyle:'solid', borderWidth:'1px'}}>
                <Text style={{width:'8%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>S.No</Text>
                <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Batch No</Text>
                <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Course</Text>
                <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Total Copies</Text>
                <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Absent</Text>
                <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Copies Examined</Text>
                <Text style={{width:'7%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>Rate</Text>
                <Text style={{width:'10%',textAlign:'right', marginRight:'5', fontSize:'10'}}>Amount</Text>
            </View>
            {po.batches.map((i,k) => (
                <View key={k} style={{margin:'0 10 0 20', padding:'2px',display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'solid', borderWidth:'1px'}}>
                    <Text style={{width:'8%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>{k+1}</Text>
                    <Text style={{width:'15%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>{i.batchcode}</Text>
                    <Text style={{width:'15%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>{i.ccode}</Text>
                    <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>{i.totalcopies}</Text>
                    <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>{i.absent}</Text>
                    <Text style={{width:'15%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>{i.totalcopies - i.absent}</Text>
                    <Text style={{width:'7%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>{i.rate}</Text>
                    <Text style={{width:'10%',textAlign:'right',marginRight:'5',fontSize:'10'}}>{i.amt.toFixed(2)}</Text>
                </View>
            ))}
            <View style={{margin:'5 10 0 20', display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
            <View style={{margin:'0 10 0 20', display:'flex', flexDirection:'col'}}>
                <Text style={{textAlign:'left',marginRight:'5', fontSize:'10'}}>Gross Amount: </Text>
                <Text style={{textAlign:'left',marginRight:'5', fontSize:'10'}}>S.W.F : </Text>
                <Text style={{textAlign:'left',marginRight:'5', fontSize:'10'}}>T.D.S.: </Text>
                <Text style={{textAlign:'left',marginRight:'5', fontSize:'10'}}>Net Amount: </Text>
            </View>
            <View style={{margin:'0 0 0 20', display:'flex', flexDirection:'col', alignItems:'flex-end'}}>
                <Text style={{marginRight:'5', fontSize:'10'}}>{po.gross.toFixed(2)}</Text>
                <Text style={{marginRight:'5', fontSize:'10'}}>{po.swf.toFixed(2)}</Text>
                <Text style={{marginRight:'5', fontSize:'10'}}>{po.tds.toFixed(2)}</Text>
                <Text style={{marginRight:'5', fontSize:'10'}}>{po.netamt.toFixed(2)}</Text>
            </View>
            </View>
            <View style={{margin:'10 10 0 20', display:'flex', flexDirection:'col', alignItems:'flex-end'}}>
                <Text style={{marginRight:'5', fontSize:'10', textTransform:'capitalize'}}>Amount In words: {toWords.convert(po.netamt, { currency: true , ignoreZeroCurrency: true})}.</Text>
            </View>
            <View style={{margin:'0 10 0 20', height:'70px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>Received and Accepted</Text>
                <Text style={{fontSize:'9', margin:'0',borderRightWidth:'1px',}}></Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>Signature of Examiner</Text>
            </View>
        </Page>
    </Document>);
    }
    return (
        <PDFViewer style={{height:'100vh'}} width="100%" showToolbar={true}>
            {pdfDoc}
        </PDFViewer>
    );
};

const mapStateToProps = state => {
    return {
        username: state.auth.username,
        userid: state.auth.userid,
        email: state.auth.email,
        isAuth: state.auth.token !== null,
        }
}

export default connect(mapStateToProps)(Billprint);